var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { PopupDatePicker, StaticDatePicker } from './components';
export const DatePicker = ({ value = new Date(), ...props }) => props.calendarPlacement === 'static' ? (_jsx(StaticDatePicker, { ...props, value: value })) : (_jsx(PopupDatePicker, { ...props, value: value }));
_react_refresh_temp_1 = DatePicker;
$RefreshReg$(_react_refresh_temp_1, "DatePicker");
